import * as Sentry from '@sentry/react'
import {
  forensicsParams,
  forensicsResultMode,
  forensicsStyles,
  getRandomForensicsActions
} from 'components/views/Biometry/forensics-config'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FLOW_STEPS } from 'share/types'
import { ModeApp } from 'utils/constants'

const OzLivenessToken = import.meta.env.VITE_OZ_LIVENESS_TOKEN

interface OzLivenessError {
  code: string
  event_session_id: string
  message: string
  context: object
}

interface useForensicsProps {
  hideModalAfterSubmit?: boolean
  onSubmit: () => void
  onComplete: () => void
}

const useForensics = ({ hideModalAfterSubmit = true, onSubmit, onComplete }: useForensicsProps) => {
  const {
    i18n: { language }
  } = useTranslation()

  const runOzLiveness = useCallback(
    (id: string | number, stepName?: FLOW_STEPS) => {
      const OzLiveness = window.OzLiveness
      const config: Record<string, unknown> = {
        meta: {
          ff_llconveyer: id
        },
        lang: language,
        action: getRandomForensicsActions(),
        params: forensicsParams,
        style: forensicsStyles,
        result_mode: forensicsResultMode,
        on_complete: onComplete,
        on_submit: () => {
          if (hideModalAfterSubmit) {
            OzLiveness.hide()
          }
          onSubmit()
        },
        on_error: (error: OzLivenessError) => {
          Sentry.captureException(error, scope => {
            scope.clear()
            scope.setTag('step_name', stepName)
            scope.setTag('step_id', id)
            scope.setTag('biometry_error_code', error.code)
            return scope
          })
        }
      }
      if (ModeApp === 'development') {
        config['token'] = OzLivenessToken
      }
      OzLiveness.open(config)
    },
    [hideModalAfterSubmit, language, onComplete, onSubmit]
  )

  return runOzLiveness
}

export { useForensics }
